import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    label: 'fw-bold',
    carouselContainer: 'gap-4',
    stickyFooter: 'space-y-4',
    wrapperInline: 'lg:(absolute -top-8 -inset-x-2 z-3 bg-white pt-8 pb-4 px-2)',
    wrapperModal: 'lg:(grid gap-4 mt-4)'
  },
  brandStyles: {
    wrapper: {
      'grid-cols': {
        lg: 'minmax(0, 1fr) minmax(0, 0.85fr)'
      }
    }
  },
  dialogOptions: {
    type: {
      sm: 'panel',
      md: 'modal'
    }
  },
  gallery: {
    pagination: true,
    presets: {
      src: {
        height: 613,
        width: 527
      }
    }
  },
  titleTranslationKey: 'addToCart',
  viewDetailsVariant: 'tertiary'
} satisfies RecursivePartial<DialogConfig['quickshop']>
